import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CHAINS } from '../../../constants';
import { useGlobalState } from '../../../state/GlobalStateProvider';
import Logo from '../../Logo/Logo';
import './ProjectChip.scss';

const ProjectChip = ({ project, big = false, tags }) => {
  const navigate = useNavigate();
  const [projectData, setProjectData] = useState();
  const [{ protocolMapping }] = useGlobalState();

  function handleRedirect(event) {
    event.stopPropagation();
    navigate(`/takes/feed/?project=${project}`);
  }

  useEffect(() => {
    if (!project) return;
    if (String(project).startsWith('chain')) {
      const chainId = Number(String(project).split('-')?.[1]);
      setProjectData(CHAINS[chainId]);
    } else {
      setProjectData(protocolMapping?.[project]);
    }
  }, [project, protocolMapping]);

  return (
    <div className={`projectchip_wrapper ${big && 'projectchip_big'}`} onClick={handleRedirect}>
      <div className='projectchip_wrapper_logo'>
        <Logo src={projectData?.logo} width={big ? '2.5rem' : '1.45rem'} height={big ? '2.5rem' : '1.45rem'} borderRadius='50%' />
      </div>
      {projectData?.name} {tags?.length > 0 && `/ ${tags[0]}`}
    </div>
  );
};

export default ProjectChip;
